import { INTEGRATIONS } from "@/data/content";

export default function MarqueeLogos({ inverse = false }) {
  const list = [...INTEGRATIONS, ...INTEGRATIONS];
  const color = inverse ? "text-[#F8F7F4]" : "text-[#0A140F]";
  const border = inverse ? "border-[#2A3E37]" : "border-[#D6D2C4]";
  return (
    <div className={`overflow-hidden border-y ${border}`} data-testid="marquee-logos">
      <div className="marquee-track flex">
        {list.map((x, i) => (
          <div
            key={i}
            className={`shrink-0 px-8 py-5 font-mono font-bold tracking-[0.22em] text-xs ${color} border-r ${border}`}
          >
            {x}
          </div>
        ))}
      </div>
    </div>
  );
}
